/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Booking Engine
 * Hotel search and booking microservice for Herika SaaS
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdaptersListResponse,
  ConnectAdapterRequest,
  ConnectAdapterResponse,
  CredentialSchemaResponse,
  HTTPValidationError
} from '.././schemas';

import { axiosInstance } from '../../axios-instance';
import type { ErrorType , BodyType } from '../../axios-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * List connected and available supplier adapters.

- Regular users see the adapters connected to their own external
  accounts (workspace EAs + org-level EA) as `connected`, and the
  remaining active adapters as `available` for onboarding.
- Cross-tenant Herika super-admins (``herika-admin`` realm role) see
  every active adapter as `connected` with a placeholder EA id —
  they need a consolidated view of which suppliers are operative
  across all OTAs. For them the catalog is sourced directly from the
  ``supplier_adapters`` DB table so the registry's in-memory state
  doesn't gate the response (dev environments may boot with no
  adapter packages installed).
 * @summary List Adapters
 */
export const listAdaptersApiV1AdaptersGet = (
    
 options?: SecondParameter<typeof axiosInstance>,signal?: AbortSignal
) => {
      
      
      return axiosInstance<AdaptersListResponse>(
      {url: `/api/v1/adapters`, method: 'GET', signal
    },
      options);
    }
  



export const getListAdaptersApiV1AdaptersGetQueryKey = () => {
    return [
    `/api/v1/adapters`
    ] as const;
    }

    
export const getListAdaptersApiV1AdaptersGetQueryOptions = <TData = Awaited<ReturnType<typeof listAdaptersApiV1AdaptersGet>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdaptersApiV1AdaptersGet>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdaptersApiV1AdaptersGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdaptersApiV1AdaptersGet>>> = ({ signal }) => listAdaptersApiV1AdaptersGet(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdaptersApiV1AdaptersGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdaptersApiV1AdaptersGetQueryResult = NonNullable<Awaited<ReturnType<typeof listAdaptersApiV1AdaptersGet>>>
export type ListAdaptersApiV1AdaptersGetQueryError = ErrorType<unknown>


export function useListAdaptersApiV1AdaptersGet<TData = Awaited<ReturnType<typeof listAdaptersApiV1AdaptersGet>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdaptersApiV1AdaptersGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdaptersApiV1AdaptersGet>>,
          TError,
          Awaited<ReturnType<typeof listAdaptersApiV1AdaptersGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdaptersApiV1AdaptersGet<TData = Awaited<ReturnType<typeof listAdaptersApiV1AdaptersGet>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdaptersApiV1AdaptersGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdaptersApiV1AdaptersGet>>,
          TError,
          Awaited<ReturnType<typeof listAdaptersApiV1AdaptersGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdaptersApiV1AdaptersGet<TData = Awaited<ReturnType<typeof listAdaptersApiV1AdaptersGet>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdaptersApiV1AdaptersGet>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Adapters
 */

export function useListAdaptersApiV1AdaptersGet<TData = Awaited<ReturnType<typeof listAdaptersApiV1AdaptersGet>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdaptersApiV1AdaptersGet>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdaptersApiV1AdaptersGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Connect a new supplier by saving credentials to Controlplane.
 * @summary Connect Adapter
 */
export const connectAdapterApiV1AdaptersConnectPost = (
    connectAdapterRequest: BodyType<ConnectAdapterRequest>,
 options?: SecondParameter<typeof axiosInstance>,signal?: AbortSignal
) => {
      
      
      return axiosInstance<ConnectAdapterResponse>(
      {url: `/api/v1/adapters/connect`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: connectAdapterRequest, signal
    },
      options);
    }
  


export const getConnectAdapterApiV1AdaptersConnectPostMutationOptions = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectAdapterApiV1AdaptersConnectPost>>, TError,{data: BodyType<ConnectAdapterRequest>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof connectAdapterApiV1AdaptersConnectPost>>, TError,{data: BodyType<ConnectAdapterRequest>}, TContext> => {

const mutationKey = ['connectAdapterApiV1AdaptersConnectPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectAdapterApiV1AdaptersConnectPost>>, {data: BodyType<ConnectAdapterRequest>}> = (props) => {
          const {data} = props ?? {};

          return  connectAdapterApiV1AdaptersConnectPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConnectAdapterApiV1AdaptersConnectPostMutationResult = NonNullable<Awaited<ReturnType<typeof connectAdapterApiV1AdaptersConnectPost>>>
    export type ConnectAdapterApiV1AdaptersConnectPostMutationBody = BodyType<ConnectAdapterRequest>
    export type ConnectAdapterApiV1AdaptersConnectPostMutationError = ErrorType<HTTPValidationError>

    /**
 * @summary Connect Adapter
 */
export const useConnectAdapterApiV1AdaptersConnectPost = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectAdapterApiV1AdaptersConnectPost>>, TError,{data: BodyType<ConnectAdapterRequest>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof connectAdapterApiV1AdaptersConnectPost>>,
        TError,
        {data: BodyType<ConnectAdapterRequest>},
        TContext
      > => {

      const mutationOptions = getConnectAdapterApiV1AdaptersConnectPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Return the credential fields required to connect a supplier.
 * @summary Get Credential Schema
 */
export const getCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet = (
    supplierCode: string,
 options?: SecondParameter<typeof axiosInstance>,signal?: AbortSignal
) => {
      
      
      return axiosInstance<CredentialSchemaResponse>(
      {url: `/api/v1/adapters/${supplierCode}/credential-schema`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGetQueryKey = (supplierCode?: string,) => {
    return [
    `/api/v1/adapters/${supplierCode}/credential-schema`
    ] as const;
    }

    
export const getGetCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGetQueryOptions = <TData = Awaited<ReturnType<typeof getCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet>>, TError = ErrorType<HTTPValidationError>>(supplierCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGetQueryKey(supplierCode);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet>>> = ({ signal }) => getCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet(supplierCode, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(supplierCode),  staleTime: 300000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGetQueryResult = NonNullable<Awaited<ReturnType<typeof getCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet>>>
export type GetCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGetQueryError = ErrorType<HTTPValidationError>


export function useGetCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet<TData = Awaited<ReturnType<typeof getCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet>>, TError = ErrorType<HTTPValidationError>>(
 supplierCode: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet>>,
          TError,
          Awaited<ReturnType<typeof getCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet<TData = Awaited<ReturnType<typeof getCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet>>, TError = ErrorType<HTTPValidationError>>(
 supplierCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet>>,
          TError,
          Awaited<ReturnType<typeof getCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet<TData = Awaited<ReturnType<typeof getCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet>>, TError = ErrorType<HTTPValidationError>>(
 supplierCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Credential Schema
 */

export function useGetCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet<TData = Awaited<ReturnType<typeof getCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet>>, TError = ErrorType<HTTPValidationError>>(
 supplierCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGet>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCredentialSchemaApiV1AdaptersSupplierCodeCredentialSchemaGetQueryOptions(supplierCode,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




